import React, { PureComponent } from "react";
import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Line } from "recharts";

export default class ChartVertical extends PureComponent<any> {
    UNSAFE_componentWillReceiveProps() {}
    render() {
        return (
            <ResponsiveContainer width="100%" height={this.props.base_height}>
                <ComposedChart
                    layout="vertical"
                    width={500}
                    height={this.props.base_height}
                    data={this.props.data}
                    margin={{
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20,
                    }}
                >
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis type="number" />
                    <YAxis width={250} dataKey="name" type="category" />
                    <Line type="monotone" dataKey="persentase" stroke="#ff7300" />
                    <Tooltip
                        separator=""
                        // content={
                        //     //@ts-ignore
                        //     <this.CustomizedTooltip />
                        // }
                        // wrapperStyle={{ backgroundColor: "red" }}
                        // labelStyle={{ color: "green" }}
                        // itemStyle={{ color: "cyan" }}
                        formatter={(value, name, props) => {
                            let tl = this.props.total;
                            if (name === "persentase") {
                                return [`${value}% dari total ${tl} terbitan`];
                            } else {
                                return [`${value} terbitan`];
                            }
                            // return [`${value} %`, "formatted name"];
                        }}
                        labelFormatter={function (value) {
                            return `${value}`;
                        }}
                    />
                    {/* <Bar dataKey="pv" barSize={20} fill="#413ea0" label={<this.Custom />} /> */}
                    <Bar dataKey="terbitan" barSize={20} fill="#8884D8" />
                </ComposedChart>
            </ResponsiveContainer>
        );
    }
}
